import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import { OnChanges, Input, Component } from '@angular/core';

@Component({
  selector: 'app-movement-indicator',
  template: `
    <div [@changeState]="changeState" style="text-align: center">
      @if (isPremium) {
        {{ value | number: '1.0-0' }}
      } @else {
        {{ value | percent: '1.3-3' }}
      }
    </div>
  `,
  animations: [
    trigger('changeState', [
      state('positive', style({ color: 'var(--positive-green)' })),
      state('negative', style({ color: 'var(--negative-red)' })),
      transition('* => positive', [
        animate('300ms ease-out', style({ color: 'var(--positive-green)' }))
      ]),
      transition('* => negative', [
        animate('300ms ease-out', style({ color: 'var(--negative-red)' }))
      ])
    ])
  ]
})
export class MovementIndicatorComponent implements OnChanges {
  @Input() public value!: number;
  @Input() public isPremium: boolean;
  public changeState: 'positive' | 'negative' | 'neutral' = 'neutral';
  private previousValue?: number;

  public ngOnChanges() {
    if (this.previousValue !== undefined) {
      if (this.value > this.previousValue) {
        this.changeState = 'positive';
      } else if (this.value < this.previousValue) {
        this.changeState = 'negative';
      }

      setTimeout(() => (this.changeState = 'neutral'), 300);
    }
    this.previousValue = this.value;
  }
}
